module.exports = __webpack_public_path__ + "img/vinyl-wallpaper.db88608d.png";